import { matchesRouteBase } from '@/services/platformRouting'

export const VISIBLE_NESTED_ITEMS = 4

const firstFewPlusCurrent = (items, path) => [
  ...items.slice(0, VISIBLE_NESTED_ITEMS),
  ...(path ? items.slice(VISIBLE_NESTED_ITEMS).filter(item => isNavLinkActive(path, item)) : [])
]

export const capped = (items, showAll, path) => {
  const shown = showAll ? items : firstFewPlusCurrent(items, path)
  return {
    children: shown,
    hiddenCount: items.length - shown.length,
    canShowFewer: showAll && items.length > VISIBLE_NESTED_ITEMS
  }
}

export const cappedList = (items, list, expanded = [], path) => {
  if (items.length <= VISIBLE_NESTED_ITEMS) return items
  if (expanded.includes(list)) return [...items, { toggle: 'fewer', list }]
  const shown = firstFewPlusCurrent(items, path)
  return shown.length === items.length
    ? shown
    : [...shown, { toggle: 'more', list, count: items.length - shown.length }]
}

export const withOverview = (overview, { children, ...rest }) => ({ ...rest, children: [overview, ...children] })

export const isNavLinkActive = (path, item) => {
  if (item.exclude?.includes(path)) return false
  if (item.exact) return item.exact.includes(path)
  if (item.match) return item.match.some(base => matchesRouteBase(path, base))
  return path === item.link
}

export const isSectionPath = (path, bases = []) => bases.some(base => matchesRouteBase(path, base))
